import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=7a549be0"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports